/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_UnknownInputs */



/**
* | output |
* | --- |
* | "No longer in your calendar" |
*
* @param {Meetings_Exception_UnknownInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_unknown = /** @type {((inputs?: Meetings_Exception_UnknownInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_UnknownInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Staat niet meer in je agenda")
	if (locale === "fr") return /** @type {LocalizedString} */ ("N'est plus dans votre agenda")
	return /** @type {LocalizedString} */ ("No longer in your calendar")
});